import React from 'react';
import { COLORS } from '../../utils';
import { IIconParentProps } from './index';

const listSmallIcon: React.FC<IIconParentProps> = ({
	className,
	hexFill: fill,
	viewBox,
	onClick,
}) => {
	const hexFill = fill || COLORS.nebula;
	return (
		<svg
			onClick={onClick}
			className={className || ''}
			width="4px"
			height="16px"
			viewBox={viewBox ? viewBox.join(' ') : '0 0 4 16'}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g fill="none" fillRule="evenodd">
				<g transform="translate(-541 -868)">
					<g>
						<g fill={hexFill} transform="translate(523 856) translate(18 12)">
							<circle cx="2" cy="1.5" r="1.5"/>
							<circle cx="2" cy="7.5" r="1.5"/>
							<circle cx="2" cy="13.5" r="1.5"/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

export default listSmallIcon;
